import { environment } from '@environments/environment';

/**
 * Ensures the URL is absolute by prefixing with environment.hostname if needed
 * @param url - A potentially relative or absolute URL
 * @returns An absolute URL
 */
export const resolveAbsoluteUrl = (url: string): string => {
  try {
    const parsed = new URL(url);
    return parsed.toString(); // already absolute
  } catch {
    // if not absolute, prepend environment.hostname
    return new URL(url, environment.hostname).toString();
  }
};
